import React, {Component} from 'react';
import {Carousel, Modal} from 'antd';
import Cookies from 'universal-cookie';
import dayjs from 'dayjs';
import {updates} from './updates';

const appVersion = process.env.REACT_APP_VERSION;

class Announcement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalVisible: false,
        };
    }

    componentDidMount() {
        // Should modal be visible? only if version changed (major & minor, but not patch)
        const cookies = new Cookies();
        const cookieVersion = cookies.get('announcement_version') ?? "";

        const appVersionShort = appVersion.slice(0, appVersion.lastIndexOf('.'));
        const cookieVersionShort = cookieVersion.slice(0, cookieVersion.lastIndexOf('.'));

        this.setState({
            isModalVisible: (appVersionShort !== cookieVersionShort),
        });
    }

    onModalCancel = () => {
        const cookies = new Cookies();
        const options = {};
        const urlMode = process.env.REACT_APP_URL_MODE;
        const urlDomain = process.env.REACT_APP_URL_DOMAIN;

        options.path = '/';
        options.expires = new Date(Date.now() + (3600 * 24 * 14 * 1000)); // 14 days
        if (urlMode === 'subdomain')
            options.domain = `.${urlDomain}`;

        // Set cookies
        cookies.set('announcement_version', appVersion, options);
        this.setState({
            isModalVisible: false,
        });
    };

    renderIcon = item => {
        let iconSrc;
        if (item.icon === null)
            iconSrc = '/img/announcements/launch.png';
        else if (item.icon !== false)
            iconSrc = item.icon;

        if (iconSrc) {
            return (
                <p className="icon">
                    <img src={iconSrc} alt="" />
                </p>
            );
        }
        return null;
    };

    renderUpdates = () => updates.map(item => (
        <div key={item.key} className="step">
            { this.renderIcon(item) }
            <h1>{ item.title }</h1>
            <p className="description">
                { item.description }
            </p>
        </div>
    ));

    render() {
        const {
            isModalVisible,
        } = this.state;

        const expiryDate = dayjs('2026-08-08');
        const todayDate = dayjs();
        const isExpired = todayDate.isAfter(expiryDate);

        return (
            <Modal
                title={false}
                className="modal-announcement"
                open={isModalVisible && !isExpired}
                footer={false}
                width={380}
                onCancel={this.onModalCancel}
                zIndex={1001}
            >
                <div className="content">
                    <Carousel>
                        { this.renderUpdates() }
                    </Carousel>
                </div>
            </Modal>
        );
    }
}
export default Announcement;
